// Recognises a container state in what was said or typed - e.g. "cleared",
// "at the yard", "at sea" - for the mic on each container. The last state
// mentioned wins ("from at sea to arrived" -> Arrived).

// Longest phrases first, so "in transit" wins over "transit".
const STATES: { value: string; label: string; words: string[] }[] = [
  { value: 'IN TRANSIT', label: 'In transit', words: ['in transit', 'at sea', 'on the water', 'sailing', 'sailed', 'shipped', 'departed', 'transit'] },
  { value: 'DELIVERED', label: 'Delivered', words: ['at the yard', 'at yard', 'in the yard', 'delivered', 'delivery done'] },
  { value: 'CLEARED', label: 'Cleared', words: ['through customs', 'customs cleared', 'cleared customs', 'cleared', 'clear'] },
  { value: 'ARRIVED', label: 'Arrived', words: ['at port', 'in port', 'docked', 'landed', 'arrived', 'arrive'] },
  { value: 'BOOKED', label: 'Booked', words: ['booked', 'book'] },
  { value: 'RECEIVED', label: 'Received', words: ['received', 'checked in'] },
];

export function findState(text: string): { value: string; label: string } | null {
  const t = ` ${text.toLowerCase()} `;
  let best: { value: string; label: string; at: number } | null = null;
  for (const s of STATES) {
    for (const w of s.words) {
      const at = t.lastIndexOf(` ${w} `);
      // The last state mentioned wins ("from at sea to arrived").
      if (at >= 0 && (!best || at > best.at)) best = { value: s.value, label: s.label, at };
    }
  }
  return best ? { value: best.value, label: best.label } : null;
}
